let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iXZWD"), load("5rLJa")]).then(() => parcelRequire('hNHih'));